export const PRODUCT_COST_PAGE_NAME = "Product Cost"

export const PRODUCT_COST_PAGES = {
    TABLE: "table",
}

export const LIST_PRODUCT_COST_CELLS = [
    { id: 'shortcode',label: 'Shortcode'},
    { id: 'averageCost',label: 'Average Cost'},
    { id: 'currency',label: 'Currency'},
];

export const CURRENCIES = [
    "USD",
    "CAD"
]